import { useLayoutEffect } from 'react';

const LockBodyScroll = () => {
  useLayoutEffect(() => {
    const existingStyle = window.getComputedStyle(document.body);
    document.body.style.width = existingStyle.width;
    document.body.style.overflow = 'hidden';
    return () => (document.body.style = existingStyle);
  }, []);

  return null;
};

export default LockBodyScroll;
